/**
 * Which environment this bundle is talking to.
 *
 * There are now three (local / staging / production) and they render
 * identically, so "am I about to delete the family's real shopping list or a
 * seeded one?" is otherwise unanswerable from the screen. EnvBadge puts the
 * answer in the corner everywhere except production.
 *
 * Derived from VITE_ENV, which pwa/.env.development sets to 'local' and
 * .github/workflows/deploy.yml to 'staging'. Production sets nothing — an unset
 * value therefore has to mean production, so that forgetting the variable can
 * only ever hide the badge, never mislabel a real environment as a safe one.
 */

export type AppEnv = 'local' | 'staging' | 'production'

function read(): AppEnv {
  const raw = (import.meta.env.VITE_ENV as string | undefined)?.trim().toLowerCase()
  if (raw === 'local' || raw === 'staging') return raw
  return 'production'
}

export const APP_ENV: AppEnv = read()

export const isProduction = APP_ENV === 'production'

/** The Supabase project this bundle points at — the thing worth double-checking. */
export const SUPABASE_URL = (import.meta.env.VITE_SUPABASE_URL as string | undefined) ?? ''

/**
 * Short host label for the debug panel: the project ref for a hosted project,
 * 'localhost' for a local stack. The full URL is long enough to wrap badly on a
 * phone and the ref is the only part that identifies the project.
 */
export function supabaseLabel(url: string = SUPABASE_URL): string {
  if (!url) return 'not configured'
  try {
    const { hostname, port } = new URL(url)
    if (hostname === '127.0.0.1' || hostname === 'localhost') return `localhost:${port || '54321'}`
    return hostname.split('.')[0]
  } catch {
    return url
  }
}
